import { writable } from "svelte/store";

export const draggingFile = writable(false);
